// Centrální definice stránek a oprávnění
export const PAGES = [
  { key: "dashboard", label: "Přehled", path: "/", end: true },
  { key: "attendance", label: "Docházka", path: "/dochazka" },
  { key: "warehouses", label: "Sklady", path: "/sklady" },
  { key: "receipts", label: "Příjem surovin", path: "/prijem" },
  { key: "recipes", label: "Technologické postupy", path: "/postupy" },
  { key: "production", label: "Výroba", path: "/vyroba" },
  { key: "dispatch", label: "Expedice", path: "/expedice" },
  { key: "branch_receipts", label: "Příjem na pobočce", path: "/pobocka-prijem" },
  { key: "transfers", label: "Převod mezi pobočkami", path: "/prevody" },
  { key: "writeoffs", label: "Odpisy", path: "/odpisy" },
  { key: "inventory", label: "Inventury", path: "/inventury" },
  { key: "coffee", label: "Káva (mlýnky)", path: "/kava" },
  { key: "attendance_admin", label: "Docházky (přehled)", path: "/dochazka-prehled" },
  { key: "history", label: "Historie výroby", path: "/historie" },
];

// Výchozí oprávnění podle role, pokud uživatel nemá žádná nastavená
const DEFAULTS = {
  manager: ["dashboard", "attendance", "warehouses", "receipts", "recipes", "production", "dispatch", "branch_receipts", "transfers", "writeoffs", "inventory", "coffee", "attendance_admin", "history"],
  obsluha: ["attendance", "branch_receipts", "transfers", "writeoffs", "inventory", "coffee"],
};

export function canAccess(user, key) {
  if (!user) return false;
  if (user.role === "admin") return true;
  const perms = user.permissions || {};
  const hasAnyExplicit = Object.values(perms).some((v) => v === true);
  if (!hasAnyExplicit) {
    return (DEFAULTS[user.role] || []).includes(key);
  }
  return !!perms[key];
}

export function allowedPages(user) {
  return PAGES.filter((p) => canAccess(user, p.key));
}

export function defaultLandingPath(user) {
  const pages = allowedPages(user);
  return pages[0]?.path || "/";
}
